<mat-card>
  <mat-card-header>
    <mat-card-title>Eingegangene Zahlungen</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngIf="zahlungen && zahlungen.length; else noZahlungen">
      <table class="table">
        <tr>
          <th>Datum</th>
          <th>Art</th>
          <th>Betrag</th>
          <th *ngIf="admin">ID</th>
        </tr>
        <tr *ngFor="let item of zahlungen">
          <td>{{item.date | amCalendar}}</td>
          <td>{{item.art}}</td>
          <td style="text-align:right">{{item.betrag | preis}}</td>
          <td *ngIf="admin">{{item.id}}</td>
        </tr>
        <tr>
          <th colspan="2">Gesamt</th>
          <th style="text-align:right">{{user.zahlungenSumme | preis}}</th>
          <td *ngIf="admin"></td>
        </tr>
      </table>
    </ng-container>
    <ng-template #noZahlungen>
      Keine Zahlungen vorhanden.
    </ng-template>
  </mat-card-content>
</mat-card>
